import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, type ReactNode } from 'react';
import { SUITE_NAME } from '../../shell/SuiteShell';

/**
 * Il testo degli avvisi standard di MUI è a circa 6,7:1 sul loro sfondo: qui serve almeno 7:1
 * (WCAG 2.2 AAA, 1.4.6), quindi le tinte più scure della palette.
 */
const AAA_ALERTS_SX = {
  '& .MuiAlert-standardError': { color: 'error.darker' },
  '& .MuiAlert-standardWarning': { color: 'warning.darker' },
} as const;

/**
 * Cornice delle pagine dell'autorizzazione MCP: fuori dalla shell della suite, come la pagina di
 * accesso (PAGE-005), perché ci si arriva dal client (Claude, Cursor) e se ne esce verso il client.
 */
export function McpAuthorizationLayout({ title, children }: { title: string; children: ReactNode }) {
  // Titolo della scheda (WCAG 2.4.2): ci si arriva da un client esterno, in una scheda nuova.
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · ${SUITE_NAME}`;
    return () => {
      document.title = previous;
    };
  }, [title]);

  return (
    <Box
      component="main"
      sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'grey.100', px: 2, py: 6 }}
    >
      <Paper variant="outlined" sx={{ p: { xs: 3, sm: 5 }, width: '100%', maxWidth: 560, ...AAA_ALERTS_SX }}>
        <Stack spacing={3}>
          <Typography variant="overline" component="p" sx={{ color: 'text.primary', fontWeight: 600 }}>
            {SUITE_NAME}
          </Typography>
          <Typography variant="h4" component="h1">
            {title}
          </Typography>
          {children}
        </Stack>
      </Paper>
    </Box>
  );
}
